export const NAV_BAR_HEIGHT = 'var(--uicomponents-global-nav-height, 54px)';
export const TABS_ACTIVATE_TRANSITION_TIMING = '200ms';